import React, { useState, useEffect, useCallback } from 'react';
import { connect } from 'react-redux';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { Typography } from '@material-ui/core';
import { getCoverageCodes } from 'state/actions';

const CoverageCodeSelect = ({
  label = 'Coverage Codes',
  id,
  defaultValue = [],
  name,
  multiple = false,
  onChange = () => {},
  coverageCodes: { loading: coverageCodesLoading, values: coverageCodes },
  dispatch,
}) => {
  const [value, setValue] = useState([]);
  const [inputValue, setInputValue] = useState('');
  const [options, setOptions] = useState([]);
  const [defaultValuesSet, setDefaultValuesSet] = useState(false);

  useEffect(() => {
    dispatch(getCoverageCodes());
  }, [dispatch]);

  useEffect(() => {
    setOptions([
      ...(coverageCodes && coverageCodes.length
        ? coverageCodes.reduce((acc, { coverageCodeId, coverageCodeName }) => {
            acc.push({ id: coverageCodeId, label: coverageCodeName });
            return acc;
          }, [])
        : []),
    ]);
  }, [coverageCodes]);

  const handleChange = useCallback(
    (event, newValue) => {
      setValue(newValue);
      if (!multiple) {
        let selectedValue = newValue
          ? [{ id: newValue.id, label: newValue.label }]
          : [{ id: 0, label: '' }];
        onChange({ name: name, value: selectedValue });
      } else {
        onChange({ name: name, value: newValue });
      }
    },
    [name, onChange, multiple],
  );

  useEffect(() => {
    if (defaultValue.length > 0 && options.length > 0 && !defaultValuesSet) {
      const cleaned = typeof defaultValue === 'string' ? defaultValue.split(',') : defaultValue;
      const values = cleaned.reduce((acc, coverageCodeId) => {
        const coverageCode = options.find(
          ({ id: coverageCodeId2 }) => coverageCodeId.toString() === coverageCodeId2.toString(),
        );
        if (coverageCode) {
          acc.push(coverageCode);
        }
        return acc;
      }, []);
      if (!multiple) {
        setValue(values[0]);
      } else {
        setValue(values);
      }
      setDefaultValuesSet(true);
    }
  }, [defaultValue, defaultValuesSet, options, multiple]);

  const handleInputChange = (event, newInputValue) => {
    setInputValue(newInputValue);
  };

  return (
    <div>
      {options.length > 0 ? (
        <Autocomplete
          multiple={multiple}
          value={value}
          onChange={handleChange}
          inputValue={inputValue}
          onInputChange={handleInputChange}
          name={name}
          id={id}
          options={options}
          style={{ width: '100%' }}
          renderInput={(params) => <TextField {...params} label={label} />}
          getOptionLabel={(option) => option.label}
        />
      ) : (
        <Typography variant="body1">Loading coverage codes...</Typography>
      )}
    </div>
  );
};

const mapStateToProps = ({ coverageCodes = { loading: true, values: [] } }) => ({
  coverageCodes,
});

export default connect(mapStateToProps)(CoverageCodeSelect);
